export const ASSIGNED_TO_TAB_REQUEST = "ASSIGNED_TO_TAB_REQUEST";
export const ASSIGNED_TO_TAB_RESULT = "ASSIGNED_TO_TAB_RESULT";